import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mediaQueries } from '../../../style/global-style';
import {
    DreamlinesButton,
    IDreamlinesButton,
} from '../../atoms/dreamlines-button/dreamlines-button';

interface IStyledCard {
    sticky?: boolean;
    hide?: boolean;
    noTabs?: boolean;
    stageModuleType?: string;
}

export const StyledNavTabs = styled.div`
    position: relative;
    z-index: -1;
`;

export const StyledSticky = styled.div<IStyledCard>`
    ${(props) =>
        props.hide &&
        !props.sticky &&
        css`
            overflow: hidden;
            opacity: 0;
            height: 0;
        `}
    position: relative;
    z-index: 1;
    & > div:nth-child(1) {
        display: ${({ sticky, stageModuleType }) => {
            if (stageModuleType !== 'searchStage') {
                return 'none';
            }
            return !sticky ? 'none' : 'flex';
        }};
    }
    ${StyledNavTabs} {
        ${(props) =>
            props.sticky
                ? css`
                      transition: 0.5s all 0.3s;
                      visibility: unset;
                      opacity: 1;
                      transform: translate3d(0, 0, 0);
                  `
                : css`
                      visibility: ${props.stageModuleType === 'searchStage' ? 'visible' : 'hidden'};
                      opacity: ${props.stageModuleType === 'searchStage' ? '1' : '0'};
                      transform: translate3d(0, -100%, 0);
                  `}
    }
`;

export const Row1 = styled.div`
    display: flex;
    align-items: center;

    ${(props: { wrap: 'true' | 'false' }) => {
        return props.wrap === 'true'
            ? css`
                  flex-wrap: wrap;
              `
            : null;
    }}
`;

export const Row2 = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const StyledCard = styled.div<IStyledCard>`
    max-width: calc(1920px - 20px * 2);
    width: calc(100% - 20px * 2);
    background-color: ${(props) => props.theme.shades.white};
    color: ${(props) => props.theme.shades.blackGrey};
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
    transition: 0.5s all;
    margin-left: auto;
    margin-right: auto;

    /* Restrict the width of title container in mobile */
    @media ${mediaQueries.phone} {
        > ${Row1} {
            max-width: 42%;
        }
    }
    /* Fix static price component to come in 1 line for small mobile device with specific font sizes. */
    @media (max-width: 360px) {
        > ${Row1} {
            max-width: 40%;
        }
    }
    ${(props) =>
        props.sticky
            ? css`
                  max-width: none;
                  width: 100%;
                  flex-direction: row;
                  justify-content: space-between;
                  margin-top: 0;
                  margin-bottom: 0;
                  box-shadow: 0;
                  padding: 0;
                  height: 65px;
                  align-items: center;
                  padding-left: 10px;
                  @media ${mediaQueries.desktopAndUp} {
                      padding-left: 20px;
                  }
                  @media ${mediaQueries.tablet} {
                      ${StyledPriceAndButton} {
                          button {
                              min-width: unset;
                              font-size: ${props.theme.fontSize.copyTextL};

                              span:first-child {
                                  padding-left: ${props.theme.spacing.large};
                                  padding-right: ${props.theme.spacing.large};
                              }

                              svg {
                                  width: 13px;
                                  right: ${props.theme.spacing.small};
                              }
                          }
                      }
                  }
                  ${props.noTabs &&
                  css`
                      box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.3);
                  `}
              `
            : css`
                  margin-top: 10px;
                  margin-bottom: 10px;
                  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.3);
                  @media ${mediaQueries.desktopAndUp} {
                      padding: 30px;
                  }
              `}
`;

export const StyledHeadline = styled.h2`
    font-size: ${(props) => props.theme.fontSize.copyTextXL};
    margin: 0 10px 0 0;

    @media ${mediaQueries.tabletAndUp} {
        max-width: 250px;
        font-size: ${(props) => props.theme.fontSize.headlineS};
        margin: 0 20px 0 0;
    }

    @media ${mediaQueries.desktopAndUp} {
        max-width: none;
        font-size: ${(props) => props.theme.fontSize.headlineL};
    }
`;

export const StyledPriceAndButton = styled.div<{ inRow?: boolean }>`
    display: flex;
    padding-left: ${(props) => props.theme.spacing.medium};

    button {
        @media ${mediaQueries.allMobileDevices} {
            min-width: auto;
        }
        @media ${mediaQueries.tabletAndUp} {
            min-width: 230px;
        }
        @media ${mediaQueries.desktopAndUp} {
            min-width: 260px;
        }
    }

    ${(props) =>
        props.inRow
            ? css`
                  flex-direction: row;
                  align-items: center;
                  align-self: stretch;
              `
            : css`
                  flex-direction: column;
                  align-items: flex-end;

                  button {
                      margin-top: ${props.theme.spacing.small};
                  }
              `}
`;

export const StyledBoxButton: React.ComponentType<IDreamlinesButton> = styled(DreamlinesButton)`
    && {
        border-radius: 0;
        height: 100%;
    }
`;
